import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ApiService } from '../../Shared/Services/api.service';
import { endpoints } from '../../../../environments/endpoints';
import { LaravelDefaultResponse } from '../../../Interfaces/api/shared/response.interface';
import { ImpersonationResponse } from '../../../Interfaces/api/backoffice/impersonation.interface';

@Injectable({
  providedIn: 'root',
})
export class ImpersonationService {
  private readonly _apiService = inject(ApiService);

  issue(userId: string, reason: string | null): Observable<ImpersonationResponse> {
    const request = this._apiService.post<LaravelDefaultResponse<ImpersonationResponse>>(
      endpoints.backoffice.impersonate,
      { body: { user_id: userId, reason }, skipError: true },
    );

    return this._apiService
      .run<LaravelDefaultResponse<ImpersonationResponse>>(request)
      .pipe(map((response) => response.data));
  }
}
